export default "__VITE_ASSET__1ddcc2e2__"